import React from 'react'

function FormularioContacto({handleChange,handleSubmit,formData}) {
  return (
    <form onSubmit={handleSubmit} className="bg-white shadow-carritoshadow mx-auto rounded-lg p-6 mb-12 w-10/12">
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
      {/* Email */}
      <div className="col-span-1">
        <label className="block font-bold mb-2">Email de contacto</label>
        <input
          type="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          className="w-full p-2 border rounded-md  border-Negro"
          placeholder="email@example.com"
          required
        />
      </div>
      
      {/* Motivo */}
      <div className="col-span-1">
        <label className="block font-bold mb-2">Motivo</label>
        <input
          type="text"
          name="motivo"
          value={formData.motivo}
          onChange={handleChange}
          className="w-full p-2 border rounded-md  border-Negro"
          placeholder="Escribe el motivo"
          required
        />
      </div>
    </div>

    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
      {/* Nombre */}
      <div className="col-span-1">
        <label className="block font-bold mb-2">Nombre</label>
        <input
          type="text"
          name="nombre"
          value={formData.nombre}
          onChange={handleChange}
          className="w-full p-2 border rounded-md border-Negro"
          placeholder="Tu nombre"
          required
        />
      </div>
      
      {/* Teléfono */}
      <div className="col-span-1 flex space-x-1">
  {/* Cod. área */}
  <div className="flex-grow-0 flex-shrink md:flex-shrink-1 basis-1/5">
    <label className="block font-bold mb-2">Área</label>
    <input
      type="text"
      name="codArea"
      value={formData.codArea}
      onChange={handleChange}
      className="w-full p-2 border rounded-md border-Negro"
      placeholder="011"
      required
    />
  </div>
  {/* Teléfono */}
  <div className="flex-grow flex-shrink basis-3/5 md:basis-4/5">
    <label className="block font-bold mb-2">Teléfono</label>
    <input
      type="text"
      name="telefono"
      value={formData.telefono}
      onChange={handleChange}
      className="w-full p-2 border rounded-md border-Negro"
      placeholder="1234-5678"
      required
    />
  </div>
</div>

    </div>

    {/* Mensaje */}
    <div className="mb-4">
      <label className="block font-bold mb-2">Mensaje</label>
      <textarea
        name="mensaje"
        value={formData.mensaje}
        onChange={handleChange}
        className="w-full p-2 border rounded-md border-Negro"
        rows="4"
        placeholder="Escribe tu mensaje aquí..."
        required
      ></textarea>
    </div>

    {/* Botón de enviar */}
    <div className="flex justify-center">
    <button className="w-3/5 lg:w-2/5 h-14 lg:h-14 text-Blanco text-lg bg-Verde border border-Negro py-2 font-bold rounded-lg">Enviar Consulta</button>
    </div>
  </form>
  )
}

export default FormularioContacto